
import { Vue } from "vue-class-component";

export default class ArrowDown extends Vue {}
